import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { format } from "date-fns";
import { Button } from "primereact/button";
import { IPermissionProps } from "../../../../models/Login";
import { Fetch } from "../../../../shared/Fetch";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { Toolbar } from "primereact/toolbar";

export interface ICategory {
    category_ID?: number,
    category_Name?: string,
    category_Description?: string,
    category_Status?: boolean,
    added_On?: Date,
    added_By?: string,
    updated_On?: Date,
    updated_By?: string,
}

export const emtypCategory: ICategory = {
    category_Name: "",
    category_Description: "",
    category_Status: true,
};

interface IProps {
    setModal: (modal: { open: boolean, singleData: ICategory }) => void,
    permissions: IPermissionProps,
    reload: boolean,
    toast: any,
    openTopicModal: (category_ID: number) => void
}

export const Table = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ICategory>, loading: boolean });
    const dt = useRef<any>(null);

    const header = () => {
        return <p>Training Categories</p>
    }

    const fromDate = (rowData: ICategory) => {
        let date;
        if (rowData.added_On) date = format(new Date(rowData.added_On), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const toDate = (rowData: ICategory) => {
        let date;
        if (rowData.updated_On) date = format(new Date(rowData.updated_On), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const openEdit = (data: ICategory) => {
        props.setModal({ open: true, singleData: data });
    }

    const RemoveTeam = async (rowData: ICategory) => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("CarnivalTraining/removeCategory", "DELETE", null, `category_ID=${rowData.category_ID}`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Team Removed", life: 3000 });
            loadTableData();
        }
    }

    const rejectFunc = () => {
        props.toast.current.show({ severity: "error", detail: "You have Canceled", life: 3000 })

    }

    const confirmDelete = (rowData: ICategory) => {
        confirmDialog({
            message: `Are you sure you want to delete this Category`,
            header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            // defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            accept: () => RemoveTeam(rowData),
            reject: () => rejectFunc()
        });
    }

    const action = (rowData: ICategory) => {
        return (
            <div className="flex gap-3">
                {props.permissions.is_Update && <Button className="pi pi-pencil text-primary bg-white border-none" onClick={() => openEdit(rowData)}></Button>}
                {props.permissions.is_Update && <Button className="pi pi-external-link text-primary bg-white border-none" onClick={() => props.openTopicModal(rowData.category_ID!)} />}
                {/* <Button className="pi pi-trash bg-white border-none" style={{color: "red"}} onClick={() => confirmDelete(rowData)}></Button> */}
                {/* {props.permissions.is_Delete && <Button className="pi pi-trash text-primary bg-white border-none" onClick={() => confirmDelete(rowData)}></Button>} */}
            </div>
        );
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("CarnivalTraining/getCategory", "GET", null, null, props.toast);
        if (response) {
            const data: ICategory[] = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const leftToolbarTemplate = () => {
        return (

            <React.Fragment>
                <div className="my-2">
                    {props.permissions.is_Create && <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />}
                </div>
            </React.Fragment>
        );
    };

    const openNew = () => {
        props.setModal({ open: true, singleData: emtypCategory });
    };

    const onToggle = async (data: ICategory) => {
        const method = "PUT";
        const message = "Updated Successfully";
        const url = "toggleCategoryStatus";
        delete data.added_On;
        delete data.added_By;
        delete data.updated_On;
        delete data.updated_By;

        const response = await Fetch(("CarnivalTraining/" + url), method, data, null, props.toast);

        if (response) {
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            loadTableData();
        }
    }

    const status = (data: ICategory) => {
        return <p className="cursor-pointer underline" onClick={() => {
            if (props.permissions.is_Update) { onToggle(data); }
        }} style={{ color: (data.category_Status === true ? "green" : "red") }}>{data.category_Status === true ? "Active" : "Inactive"}</p>
    }

    useEffect(() => {
        loadTableData();
    }, [props.reload]);

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                lazy dataKey="category_ID"
                emptyMessage="No Record found."
                value={tableData.tableData} loading={tableData.loading}
                header={header}>
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="category_Name" header="Category" />
                <Column field="category_Description" header="Description" />
                <Column field="added_By" header="Added By" />
                <Column field="added_On" header="Added On" body={(rowData: ICategory) => fromDate(rowData)} />
                <Column field="updated_By" header="Updated By" />
                <Column field="updated_On" header="Updated On" body={(rowData: ICategory) => toDate(rowData)} />
                <Column field="category_Status" header="Status" body={(rowData: ICategory) => status(rowData)} />
                <Column field="" header="Action" body={action} />
            </DataTable>
            <ConfirmDialog />
        </>
    );
}